import { render, staticRenderFns } from "./FAQCard.vue?vue&type=template&id=18029463&scoped=true&"
import script from "./FAQCard.vue?vue&type=script&lang=js&"
export * from "./FAQCard.vue?vue&type=script&lang=js&"
import style0 from "./FAQCard.vue?vue&type=style&index=0&id=18029463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18029463",
  null
  
)

export default component.exports